import React from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { Menu, Divider, Tooltip } from 'antd';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSelector } from 'react-redux';
import { access } from '../../../common/Tool';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function SideMenu({ title, path, menu, noDivider }) {
    let navigate = useNavigate();
    const getLast = (path) => {
        if(!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if(!lst) return;
        return lst
    }
    const getBase = (path) => {
        if(!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const last = getLast(path);
    const base = getBase(path);
    
    // console.log(base,last);
    // let match = useMatch({
    //     path: path,
    //     // path: "/app/:one/:two/:three",
    //     caseSensitive: false,
    //     end: false
    // })

    // console.log(path, match);

    const role_by_id = useSelector(state => state.home.role_by_id);

    if (!menu || !menu.length) return (<></>);
    const l = (element, key) => {
        const icon = (element.icon) ? element.icon(element) : <></>;
        return ({
            label: (element.href) ?
                (
                    <a /*className='btn-pointer'*/ style={{fontWeight:"400"}} href={element.href} target="_blank" rel="noopener noreferrer">
                        {element.name} <i className="fa fa-external-link" style={{fontSize:"10px", color:"rgb(22, 119, 255)"}}></i>
                    </a>
                ) :
                (<Tooltip title={element.name} mouseEnterDelay={0.8}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {element.name}
                        </div>
                    </div>
                </Tooltip>),
            key: key,
            icon: icon,
            disabled: element.disabled,
        })
    }
    const elements = menu.map((element, index) => {
        const key = element.uuid || element.key || index;
        if (element.hidden || element.unvisible) {
            return
        }
        if (element.component && access(element, role_by_id)) {
            return l(element, key)
        }
        if (element.href && access(element, role_by_id)) {
            return l(element, key)
        }
    })
    const change = ({ item, key, keyPath, domEvent }) => {
        if(domEvent.target.localName === "a"){
            return
        }
        // navigate("../".repeat(levelCorrection) + key);
        navigate(base+"/"+key)
    }
    return (
        <>
            {(!noDivider === true) && <Divider type="horizontal"
                orientation="left"
                style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
                {title}
            </Divider>}
            <Menu
                className={"menu-level-two"}
                mode="inline"
                // defaultSelectedKeys={[match?.params?.uuid]}
                // selectedKeys={[match?.params?.uuid]}

                defaultSelectedKeys={(last)?[last]:undefined}
                selectedKeys={(last)?[last]:undefined}

                style={{ border: "none", margin: "0px" }}
                inlineIndent={10}
                onClick={change}
                items={elements}
            />
        </>
    )
}
